module.exports = __webpack_public_path__ + "static/img/image_news_over_08.8ff77e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_over_08.png
// module id = PjEg
// module chunks = 10